import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DsAbstractButtonComponent } from '@abstract/components/ds-abstract-button.component';

@Component({
  selector: 'ds-button',
  templateUrl: './ds-button.component.html',
  styleUrls: ['./ds-button.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, RouterLink, MatIconModule, MatProgressSpinnerModule, MatRippleModule, RouterLinkActive, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsButtonComponent extends DsAbstractButtonComponent {
  /**
   * Text label displayed on the button
   */
  @Input() label: string | null = null;

  @Input() iconPosition: 'before' | 'after' = 'before';

  /**
   * Returns a list of CSS classes for the button based on its current state.
   *
   * Classes are based on:
   * - button size
   * - button theme
   * - destructive or default appearance
   *
   */
  get buttonClasses(): string[] {
    return [
      'ds-button--' + this.size,
      'ds-button--' + this.theme,
      this.isDestructive ? 'ds-button--destructive' : 'ds-button--default',
      this.icon ? `ds-button--icon-${this.iconPosition}` : '',
    ];
  }
}
